const details = {
    name: "یدک بگ",
    enName: "shop",
    description: "یدک بگ، عرضه کننده قطعات برقی و سیم کشی خودرو" ,

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    }
}

export default details;
